import './Toaster.scss';
import React from 'react';
import PropTypes from 'prop-types';
import ActivitySpinner from 'components/shared/ActivitySpinner';

class LoadingToaster extends React.Component {
  static propTypes = {
    onDismiss: PropTypes.func,
    text: PropTypes.string.isRequired,
  }

  render() {
    return (
      <div className="toaster-wrapper">
        <div className="toaster-background-animated" onClick={this.props.onDismiss} />
        <div className="toaster" onClick={this.props.onDismiss}>
          <div className="toaster-content">
            <div className="toaster-icon">
              <ActivitySpinner isActive size={2} />
            </div>
            <span className="toaster-text">{this.props.text}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingToaster;
